import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Content.st.css';
import { dataHooks } from '../../constants';
import { ContentProps } from './Content.types';
import { SidePanelContext } from '../../SidePanelAPI';
import { useOverlayScrollbar } from '../../../providers/useOverlayScrollbar/useOverlayScrollbar';

const Content = ({
  children,
  scrollElementRef,
  className,
  noPadding = false,
  stretchVertically = true,
}: ContentProps) => {
  const [OverlayScrollbarHostElement, OverlayScrollbarContentElement] =
    useOverlayScrollbar();
  return (
    <SidePanelContext.Consumer>
      {({ skin }) => (
        <OverlayScrollbarHostElement
          className={st(
            classes.root,
            { noPadding, stretchVertically, skin },
            className,
          )}
          data-hook={dataHooks.sidePanelContent}
        >
          <OverlayScrollbarContentElement ref={scrollElementRef}>
            {children}
          </OverlayScrollbarContentElement>
        </OverlayScrollbarHostElement>
      )}
    </SidePanelContext.Consumer>
  );
};

Content.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  noPadding: PropTypes.bool,
  stretchVertically: PropTypes.bool,
};

export default Content;
